<template>
  <div>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>projector</title>
      <path fill="#679940"
        d="M15.92,10.46a4,4,0,1,0,4,4A4,4,0,0,0,15.92,10.46Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,15.92,16.46Z"
      />
      <path fill="#679940"
        d="M31,7.54H19.86a7.95,7.95,0,0,0-7.72,0H1a1,1,0,0,0-1,1v12a1,1,0,0,0,1,1H2.4v2.92a1,1,0,0,0,2,0V21.54h7.74a7.95,7.95,0,0,0,7.72,0H27.4v2.92a1,1,0,0,0,2,0V21.54H31a1,1,0,0,0,1-1v-12A1,1,0,0,0,31,7.54Zm-29,2H9.76a8,8,0,0,0,0,10h-6a1,1,0,0,0-.39-.08,1.06,1.06,0,0,0-.4.08H2Zm8,5a6,6,0,1,1,6,6A6,6,0,0,1,10,14.54Zm20,5H28.79a1,1,0,0,0-.39-.08,1.06,1.06,0,0,0-.4.08H22.24a8,8,0,0,0,0-10H30Z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "Projector"
};
</script>


// WEBPACK FOOTER //
// src/icons/ProjectorIcon.vue